<template>
  <div>

    <!-- Filtros -->
    <div class="card dashcard mb-0">
      <div class="card-body">
        <div class="form-row">
          <div class="col col-12 col-md-6">
            <az-periodo v-model="filtro" :sync="true" @sync="load()" />
          </div>
          <div class="col col-12" :class="( 1==1 || aba == 'dre' || ( id_unidade_operacao && ( tipo == 'R' || tipo == 'C' ) ) ) ? ( ( aba != 'dre' && id_unidade_operacao && ( tipo == 'R' || tipo == 'C' ) ) ? 'col-md-2' : 'col-md-4' ) : 'col-md-6'">
            <az-input
              :edicao="!$store.state.user.id_unidade_operacao"
              icon="far fa-building fa-fw"
              type="select"
              placeholder="Todas"
              :optionsList="$util.unidades_com_tags(true, true)"
              optionsData="id_unidade_operacao"
              v-model="id_unidade_operacao">
            </az-input>
          </div>
          <div class="col col-12 col-md-2">
              <az-input
                icon="fas fa-funnel-dollar fa-fw"
                type="select"
                placeholder="Centro de Custo..."
                :optionsList="lista_centro_custo"
                optionsData="id_centro_custo"
                :edicao="( id_unidade_operacao && !isNaN(id_unidade_operacao) ) ? true : false"
                v-model="filtro.id_centro_custo" />
          </div>
          <div class="col col-12 col-md-2" v-if="( aba != 'dre' && id_unidade_operacao && ( tipo == 'R' || tipo == 'C' ) )">
            <az-input
              icon="fa fa-filter"
              type="select"
              :optionsList="[
                { id: 'L', search: 'Unid. Lançamento' },
                { id: 'C', search: 'Unid. Conta' },
              ]"
              :edicao="( id_unidade_operacao && ( tipo == 'R' || tipo == 'C' ) ) ? true : false"
              optionsData="id"
              v-model="filtro.tipo_filtro_unidade" />
          </div>
        </div>
        <div class="form-row mt-2">
          <template v-if="aba != 'dre'">
            <div class="col col-12 col-md-2">
              <az-input
                type="select"
                optionsMode="json"
                :optionsList="[
                  { id: 'P', search: 'Previsto' },
                  { id: 'G', search: 'Previsto/Pagamento' },
                  { id: 'A', search: 'Previsto (Em Aberto)' },
                  { id: 'R', search: 'Realizado' },
                  { id: 'C', search: 'Conciliado' },
                ]"
                optionsData="id"
                v-model="tipo">
              </az-input>
            </div>
            <div class="col col-12 col-md-2" v-if="aba != 'dre'">
              <az-input
                type="select"
                icon="far fa-calendar"
                optionsData="id"
                :optionsList="[
                  { id: 'diario', search: 'Diário' }, 
                  { id: '3D', search: 'Diário (cada 3 dias)' }, 
                  { id: 'semana', search: 'Semanal' }, 
                  { id: 'mensal', search: 'Mensal' },
                  { id: 'trimestre', search: 'Trimestral' },
                ]" 
                v-model="tempo" />
            </div>
          </template>

          <div class="col col-12 col-md-2" v-if="aba != 'dre'">
            <az-input 
              type="checkbox-group"
              label="Consolidado"
              v-model="filtro.consolidado" />
          </div>

          <div class="col col-12 col-md-2" v-if="aba != 'dre'">
            <az-input 
              type="checkbox-group"
              label="Cheque Especial"
              v-model="cheque_espcial" />
          </div>


          <div class="col col-12" :class="aba != 'dre' ? 'col-md-4' : ''">
            <az-input
              icon="fa fa-search fa-fw"
              placeholder="Pesquisar..."
              v-model="filtro.search">
              <template v-slot:buttonposb>
                <print-export printid="fluxo-de-caixa" :dados="dadosFormatados" pagina="dre-fluxo-caixa" :left="true" />
              </template>
            </az-input>
          </div>
        </div>

        <div class="form-row mt-2">
          <div class="col col-12 col-md-3">
            <az-input 
              type="select"
              placeholder="Todos (Operacional/Não Operacional)..."
              :optionsList="[
                { id: 'Q', search: 'Quebra Operacional/Não Operacional' },
                { id: 'S', search: 'Operacional' },
                { id: 'N', search: 'Não Operacional' },
              ]"
              optionsData="id"
              v-model="filtro.tipo_operacional" />
          </div>

          <div class="col col-12 col-md-3">
            <az-input 
              type="checkbox-group"
              label="Particular Por Forma de Pagamento"
              v-model="particular_forma" />
          </div>

          <div class="col col-12 col-md-2">
            <az-input 
              type="checkbox-group"
              label="Exibir Média"
              :edicao="qt_colunas != 1"
              v-model="exibe_media" />
          </div>

          <div class="col col-12 col-md-2">
            <az-input 
              type="checkbox-group"
              label="Exibir Percentual"
              v-model="exibe_percentual" />
          </div>

          <div class="col col-12 col-md-2">
            <az-input 
              type="checkbox-group"
              label='"%" sobre entradas'
              :edicao="exibe_percentual"
              v-model="percentual_sobre_entradas" />
          </div>
        </div>

        <div class="form-row mt-2" v-if="lista_modelos.length">
          <div class="col col-12">
            <az-input
              icon="fa-solid fa-bars-staggered"
              type="select"
              sizing="sm"
              placeholder="Padrão"
              :optionsList="lista_modelos"
              optionsData="id_modelo_categoria" 
              v-model="id_modelo_categoria_selec" />
          </div>
        </div>
      </div>
    </div>

    <div class="progress mt-1 mb-3">
        <div class="indeterminate" v-if="$store.state.loading && dados && dados.length"></div>
        <div class="determinate" v-else></div>
    </div>

    <template v-if="!dados || !dados.length">

      <div class="alert alert-info">
        <span v-if="tipo == 'P'">
          <strong>Previsto:</strong>
          <span class="ml-1">Buscar os lançamentos abertos e baixados pela data de vencimento.</span>
        </span>

        <span v-if="tipo == 'G'">
          <strong>Previsto/Pagamento:</strong>
          <span class="ml-1">Buscar os lançamentos abertos e baixados pela data de pagamento.</span>
        </span>

        <span v-if="tipo == 'R'">
          <strong>Realizado:</strong>
          <span class="ml-1">Buscar os lançamentos baixados pela data da baixa.</span>
        </span>

        <span v-if="tipo == 'C'">
          <strong>Conciliado:</strong>
          <span class="ml-1">Buscar os lançamentos baixados e conciliados pela data da baixa.</span>
        </span>
      </div>

      <az-empty-state 
        :icon="aba == 'dre' ? 'fa-solid fa-money-bill-trend-up' : 'fa-solid fa-money-bill-transfer'" 
        :msg="firstLoad ? 'Sem lançamentos.' : 'Realizar a busca do ' + ( aba == 'dre' ? 'DRE' : 'Fluxo de Caixa' )"
        :action="firstLoad ? '' : 'Buscar'"
        :method="load" />

    </template>

    <template v-else>

      <div class="alert alert-dark d-flex justify-content-between" v-if="info_periodo">
        <div>
          Período: {{ info_periodo }}
        </div>
        <div>
          <a href="#" @click.prevent="total_frente = !total_frente" class="mr-3">
            <i class="fa-solid fa-angle-right" v-if="total_frente"></i>
            <i class="fa-solid fa-angle-left" v-else></i>
          </a>
          <a href="#" @click.prevent="toggle_expandido()">
            <i class="fa-solid fa-minimize" v-if="expandido"></i>
            <i class="fa-solid fa-maximize" v-else></i>
          </a>
        </div>
      </div>

      <!-- Fluxo de Caixa -->
      <div id="fluxo-de-caixa">

        <div class="d-none d-print-block mt-3">
          <h4>{{ $store.state.unidade.st_nome_fantasia }}</h4>
          <h3>{{ aba == 'dre' ? 'DRE' : 'Fluxo de Caixa' }}</h3>
          <div class="alert alert-secondary">
            <div v-if="parms_info && parms_info.unidade">
              {{ parms_info.unidade.st_nome }}
              <span class="ml-2" v-if="parms_info.centro && parms_info.centro.st_nome">
                ({{ parms_info.centro.st_nome }})
              </span>
            </div>
            <div>
              {{ titulo_tipo }} {{ parms_info.por_competencia ? '/ Competência' : '' }}
            </div>
            <div>
              Período: {{ info_periodo }}
            </div>
            <div v-if="parms_info && parms_info.tipo_operacional && parms_info.tipo_operacional != 'Q'">
              {{ parms_info.tipo_operacional == 'S' ? 'Operacional' : 'Não Operacional' }}
            </div>

            <div v-if="filtro.search">
              Filtro: {{ filtro.search }}
            </div>

            <div v-if="cheque_espcial">
              Saldo com Cheque Especial
            </div>
          </div>
        </div>

        <!-- Visão Consolidada -->
        <table class="table bg-white table-sm table-hover table-responsive' : 'table-responsive-md cabecalho-fixo" v-if="filtro.consolidado">
          <thead>
            <tr>
              <th>Tempo</th>
              <th class="text-right">Entradas</th>
              <th class="text-right">Saídas</th>
              <th class="text-right">Saldo</th>
              <th class="text-right">Saldo Acumulado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(items, mes, imx) in lista_mes" :key="imx" >
              <td>
                {{ $util.getFormatDate(mes, dateFormat).toUpperCase() }}
              </td>
              <td class="text-right">
                {{ getValor ({ mes: mes, 'categoria.ch_natureza': 'C' }, true, false, items.lancamentos) }}
              </td>
              <td class="text-right">
                {{ getValor ({ mes: mes, 'categoria.ch_natureza': 'D' }, true, false, items.lancamentos) }}
              </td>
              <td class="text-right" :class="getValor ({ mes: mes }, false, false, items.lancamentos) < 0 ? 'text-danger' : 'text-primary'">
                {{ getValor ({ mes: mes }, true, false, items.lancamentos) }}
              </td>
              <td class="text-right" :class="getValor ({ mes: mes }, false, true) + ( saldo_com_cheque_especial ? saldo_total : saldo ) < 0 ? 'text-danger' : 'text-primary'">
                {{ $util.formatMoeda(getValor ({ mes: mes }, false, true) + ( saldo_com_cheque_especial ? saldo_total : saldo )) }}
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Visão por Categoria -->
        <table class="table bg-white table-sm table-hover" v-else :class="( tempo == 'diario' && lista_mes && Object.keys(lista_mes).length > 10 ) ? 'table-responsive' : 'table-responsive-md cabecalho-fixo'">
          <thead>
            <tr>
              <th>Categoria</th>
              <template v-if="total_frente">
                <th class="text-right" v-if="qt_colunas > 1">Total</th>
                <th v-if="exibe_percentual" class="text-right">%</th>
                <th v-if="exibe_media && qt_colunas > 1" class="text-right">Média</th>
              </template>
              <template>
                <th v-for="(items, mes, imx) in lista_mes" :key="imx" class="text-right">
                  {{ $util.getFormatDate(mes, dateFormat).toUpperCase() }}
                </th>
              </template>
              <template v-if="!total_frente">
                <th class="text-right" v-if="qt_colunas > 1">Total</th>
                <th v-if="exibe_percentual" class="text-right">%</th>
                <th v-if="exibe_media && qt_colunas > 1" class="text-right">Média</th>
              </template>
            </tr>
          </thead>
          <tbody>
            <template v-for="(linha, ilx) in fluxo">
              <tr :key="ilx" :class="'table-' + linha.cor" v-show="validar_pesquisa(linha)" v-if="true">
                <td>
                  <a href="#" @click.prevent="toggle_expandido(linha)" class="card-link text-dark">
                    <i class="fa-solid fa-equals fa-fw mr-2" v-if="linha.formula && linha.consolid"></i>
                    <i class="fa-solid fa-square-root-variable fa-fw mr-2" v-else-if="linha.formula"></i>
                    <i class="fa-regular fa-square fa-fw mr-2" v-else-if="linha.folha"></i>
                    <i class="fa fa-minus-square-o fa-fw mr-2" aria-hidden="true" v-else-if="linha.expandido"></i>
                    <i class="fa fa-plus-square-o fa-fw mr-2" aria-hidden="true" v-else></i>
                  </a>
                  <span v-if="linha.nivel">
                    <i class="fa fa-caret-right mr-2" aria-hidden="true" v-for="nivel in linha.nivel" :key="nivel"></i>
                  </span>
                  <span v-if="linha.nivel == 1">{{ linha.search }}</span>
                  <span v-else>
                    <small>{{ linha.search }}</small>
                    <span class="badge badge-light ml-2" v-if="linha.folha && !linha.operacional" title="Não Operacional">
                      <i class="fa-solid fa-slash"></i>
                    </span>
                  </span>
                </td>

                <template v-if="total_frente">
                  <td class="text-right" v-if="qt_colunas > 1">
                    {{ getValor ({}, true, false, linha.lancamentos, false, linha) }}
                  </td>
                  <td v-if="exibe_percentual" class="text-right">
                    <span v-if="linha.cor != 'primary' || percentual_sobre_entradas">
                      {{ percentual ({}, true, false, linha.lancamentos, linha) }}%  
                    </span>
                  </td>
                  <td v-if="exibe_media && qt_colunas > 1" class="text-right">
                    {{ getValor ({}, true, false, linha.lancamentos, true, linha) }}
                  </td>
                </template>

                <template>
                  <td v-for="(items, mes, imx) in lista_mes" :key="imx" class="text-right">
                    <a href="#" @click.prevent="abrir_lancamentos(mes, linha.search, linha.lancamentos, linha.natureza, linha.id_categoria, linha.id_forma_pagamento)"
                      class="small card-link" v-if="linha.folha">
                      {{ getValor ({ mes: mes }, true, false, linha.lancamentos, false, linha) }}
                    </a>
                    <span v-else>
                      {{ getValor ({ mes: mes }, true, false, linha.lancamentos, false, linha) }}
                    </span>
                  </td>
                </template>

                <template v-if="!total_frente">
                  <td class="text-right" v-if="qt_colunas > 1">
                    {{ getValor ({}, true, false, linha.lancamentos, false, linha) }}
                  </td>
                  <td v-if="exibe_percentual" class="text-right">
                    <span v-if="linha.cor != 'primary' || percentual_sobre_entradas">
                      {{ percentual ({}, true, false, linha.lancamentos, linha) }}%  
                    </span>
                  </td>
                  <td v-if="exibe_media && qt_colunas > 1" class="text-right">
                    {{ getValor ({}, true, false, linha.lancamentos, true, linha) }}
                  </td>
                </template>
              </tr>
            </template>
          </tbody>
          <tfoot v-if="!filtro.search">
            <!-- Saldo Operacional / Não Operacional -->
            <template v-if="!parms_info || !parms_info.modelo || !parms_info.modelo.fl_block_total">
              <tr class="table-primary" v-if="tem_saldo_operacional && ( !parms_info || parms_info.tipo_operacional != 'Q' )">
                <td class="lead">
                  {{ ( aba == 'dre' || parms_info.por_competencia ) ? 'Resultado' : 'Saldo' }} Operacional
                </td>

                <template v-if="total_frente">
                  <td class="text-right" v-if="qt_colunas > 1">
                    {{ getValor ({ 'categoria.fl_operacional': true }) }}
                  </td>
                  <td v-if="exibe_percentual" class="text-right">
                    <span v-if="percentual_sobre_entradas">
                      {{ percentual ({ 'categoria.fl_operacional': true }, true, false, dados, { natureza: 'C' }) }}%  
                    </span>
                  </td>
                  <td v-if="exibe_media && qt_colunas > 1"></td>
                </template>

                <template>
                  <td v-for="(items, mes, imx) in lista_mes" :key="imx" class="text-right">
                    {{ getValor ({ 'categoria.fl_operacional': true, mes: mes }) }}
                  </td>
                </template>

                <template v-if="!total_frente">
                  <td class="text-right" v-if="qt_colunas > 1">
                    {{ getValor ({ 'categoria.fl_operacional': true }) }}
                  </td>
                  <td v-if="exibe_percentual" class="text-right">
                    <span v-if="percentual_sobre_entradas">
                      {{ percentual ({ 'categoria.fl_operacional': true }, true, false, dados, { natureza: 'C' }) }}%  
                    </span>
                  </td>
                  <td v-if="exibe_media && qt_colunas > 1"></td>
                </template>
              </tr>
              <!-- Saldo / Resultado  -->
              <tr class="table-primary">
                <td class="lead">
                  {{ ( aba == 'dre' || parms_info.por_competencia ) ? 'Resultado' : 'Saldo' }}
                </td>

                <template v-if="total_frente">
                  <td class="text-right" v-if="qt_colunas > 1">
                    {{ getValor ({}) }}
                  </td>
                  <td v-if="exibe_percentual" class="text-right">
                    <span v-if="percentual_sobre_entradas">
                      {{ percentual ({}, true, false, dados, { natureza: 'C' }) }}%  
                    </span>
                  </td>
                  <td v-if="exibe_media && qt_colunas > 1"></td>
                </template>

                <template>
                  <td v-for="(items, mes, imx) in lista_mes" :key="imx" class="text-right">
                    {{ getValor ({ mes: mes }) }}
                  </td>
                </template>

                <template v-if="!total_frente">
                  <td class="text-right" v-if="qt_colunas > 1">
                    {{ getValor ({}) }}
                  </td>
                  <td v-if="exibe_percentual" class="text-right">
                    <span v-if="percentual_sobre_entradas">
                      {{ percentual ({}, true, false, dados, { natureza: 'C', linha_saldo: true, operacional: true }) }}%
                    </span>
                  </td>
                  <td v-if="exibe_media && qt_colunas > 1"></td>
                </template>
              </tr>
            </template>

            <!-- Transferências -->
            <tr class="table-info" v-if="transfs.length">
              <td class="lead">
                Transferências
              </td>

              <template v-if="total_frente">
                <td class="text-right" v-if="qt_colunas > 1">
                  {{ $util.formatMoeda(getValorTransf ({}, false)) }}
                </td>
                <td v-if="exibe_percentual"></td>
                <td v-if="exibe_media && qt_colunas > 1"></td>
              </template>

              <template>
                <td v-for="(items, mes, imx) in lista_mes" :key="imx" class="text-right">
                  {{ $util.formatMoeda(getValorTransf ({ mes: mes }, false)) }}
                </td>
              </template>

              <template v-if="!total_frente">
                <td class="text-right" v-if="qt_colunas > 1">
                  {{ $util.formatMoeda(getValorTransf ({}, false)) }}
                </td>
                <td v-if="exibe_percentual"></td>
                <td v-if="exibe_media && qt_colunas > 1"></td>
              </template>

            </tr>

            <!-- Saldo Acumluado -->
            <template v-if="!parms_info || !parms_info.modelo || !parms_info.modelo.fl_block_total">
              <tr class="table-info" v-if="saldos.length">
                <td class="lead">
                  Saldo Acumulado
                </td>

                <template v-if="total_frente">
                  <td class="text-right" v-if="qt_colunas > 1">
                    {{ $util.formatMoeda(getValor ({}, false, true) + getValorTransf ({}, false, true) + ( saldo_com_cheque_especial ? saldo_total : saldo )) }}
                  </td>
                  <td v-if="exibe_percentual"></td>
                  <td v-if="exibe_media && qt_colunas > 1"></td>
                </template>

                <template>
                  <td v-for="(items, mes, imx) in lista_mes" :key="imx" class="text-right">
                    {{ $util.formatMoeda(getValor ({ mes: mes }, false, true) + getValorTransf ({ mes: mes }, false, true) + ( saldo_com_cheque_especial ? saldo_total : saldo )) }}
                  </td>
                </template>

                <template v-if="!total_frente">
                  <td class="text-right" v-if="qt_colunas > 1">
                    {{ $util.formatMoeda(getValor ({}, false, true) + getValorTransf ({}, false, true) +  ( saldo_com_cheque_especial ? saldo_total : saldo )) }}
                  </td>
                  <td v-if="exibe_percentual"></td>
                  <td v-if="exibe_media && qt_colunas > 1"></td>
                </template>
              </tr>
            </template>
          </tfoot>
        </table>
      </div>

      <div class="card" v-if="saldos && aba != 'dre'">
        <div class="card-body p-2" v-if="options_classes && options_classes.length">
            <a href="#" @click.prevent="( tag_selected == tag ? tag_selected = '' : tag_selected = tag ); reload();"
              v-for="(tag, itx) in options_classes" :key="itx">
              <span class="badge ml-1" :class="tag_selected == tag ? 'badge-success' : 'badge-secondary'">
                  {{ tag }}
              </span>
            </a>
        </div>

        <table class="table table-sm mb-0">
          <thead>
            <tr>
              <th>
                <a href="#" @click.prevent="exibir_composicao_saldo_inicial = !exibir_composicao_saldo_inicial">
                  <i class="fa-regular fa-square-plus fa-fw mr-2" v-if="!exibir_composicao_saldo_inicial"></i>
                  <i class="fa-regular fa-square-minus fa-fw mr-2" v-else></i>
                </a>
                Composição Saldo Inicial
              </th>
              <template v-if="exibir_composicao_saldo_inicial">
                <th class="text-right">Saldo</th>
                <template v-if="tem_cheque_especial">
                  <th class="text-right">Ch Especial</th>
                  <th class="text-right">Saldo Total</th>
                </template>
              </template>
              <template v-else>
                <th class="text-right" :class="saldo < 0 ? 'text-danger' : ''">
                  {{ $util.formatMoeda (saldo) }}
                </th>
                <template v-if="tem_cheque_especial">
                  <th class="text-right" :class="saldo_com_cheque_especial ? '' : 'text-muted'">
                    {{ $util.formatMoeda(chequeEspecial) }}
                  </th>
                  <th class="text-right" :class="saldo_com_cheque_especial ? ( saldo_total < 0 ? 'text-danger' : '' ) : 'text-muted'">
                    {{ $util.formatMoeda(saldo_total) }}
                  </th>
                </template>
              </template>
            </tr>
          </thead>
          <tbody v-if="exibir_composicao_saldo_inicial">
            <tr v-for="(conta, icx) in lista_saldos" :key="icx">
              <td>{{ conta.search }}</td>
              <td class="text-right" :class="conta.saldo < 0 ? 'text-danger' : ''">
                {{ $util.formatMoeda(conta.saldo) }}
              </td>
              <td class="text-right" :class="saldo_com_cheque_especial ? '' : 'text-muted'" v-if="tem_cheque_especial">
                {{ $util.formatMoeda(conta.dc_cheque_especial) }}
              </td>
              <td class="text-right" :class="saldo_com_cheque_especial ? ( conta.saldo_total < 0 ? 'text-danger' : '' ) : 'text-muted'" v-if="tem_cheque_especial">
                {{ $util.formatMoeda(conta.saldo_total) }}
              </td>
            </tr>
          </tbody>
          <tfoot v-if="exibir_composicao_saldo_inicial">
            <tr>
              <th>Total</th>
              <th class="text-right" :class="saldo < 0 ? 'text-danger' : ''">
                {{ $util.formatMoeda (saldo) }}
              </th>
              <template v-if="tem_cheque_especial">
                <th class="text-right" :class="saldo_com_cheque_especial ? '' : 'text-muted'">
                  {{ $util.formatMoeda(chequeEspecial) }}
                </th>
                <th class="text-right" :class="saldo_com_cheque_especial ? ( saldo_total < 0 ? 'text-danger' : '' ) : 'text-muted'">
                  {{ $util.formatMoeda(saldo_total) }}
                </th>
              </template>
            </tr>
          </tfoot>
        </table>
      </div>

      <!-- Fim Fluxo Novo -->

      <pre class="alert alert-warning" v-if="1 == 0 && fluxo">{{ fluxo }}</pre>

      <!-- 
      <div id="fluxo-de-caixa2" v-if="false">

        <div class="d-none d-print-block mt-3">
          <h4>{{ $store.state.unidade.st_nome_fantasia }}</h4>
          <h3>Fluxo de Caixa</h3>
          <div class="alert alert-secondary">
            <div>
              {{ tipo == 'P' ? 'Previsto' : ( tipo == 'C' ? 'Conciliado' : 'Realizado' ) }} {{ por_competencia ? '/ Competência' : '' }}
            </div>
            <div>
              {{ $util.getFormatDate(referencia, 'MMM/YYYY').toUpperCase() }}
            </div>
          </div>
        </div>

        <table class="table table-hover bg-white" :class="( tempo == 'diario' && lista_mes && Object.keys(lista_mes).length > 10 ) ? 'table-responsive' : 'table-responsive-md cabecalho-fixo'">
          <thead>
            <tr>
              <th>Categoria</th>
              <th v-for="(items, mes, imx) in lista_mes" :key="imx" class="text-right">
                {{ $util.getFormatDate(mes, dateFormat).toUpperCase() }}
              </th>
            </tr>
          </thead>

          <tbody>
            <tr class="table-success">
              <th class="lead">Entradas</th>
              <td v-for="(items, mes, imx) in lista_mes" :key="imx" class="text-right">
                {{ getValor ({ 'categoria.ch_natureza': 'C', mes: mes }) }}
              </td>
            </tr>

            <template v-for="(items, categoria, icx) in lista_categoria('C')">
              <tr :key="'C' + icx">
                <td>
                  {{ categoria }}
                </td>
                <td v-for="(items, mes, imx) in lista_mes" :key="icx + '-' + imx" class="text-right">
                  {{ getValor ({ 'categoria.categoria_mae.search': categoria, mes: mes }) }}
                </td>
              </tr>

              <tr v-for="(filhos, categoria_filha, ifx) in agrupar(items, 'categoria.search')" :key="'CF' + icx + '-' + ifx"
                class="small text-muted">
                <td>
                  <i class="fa fa-caret-right" aria-hidden="true"></i>
                  {{ categoria_filha }}
                </td>
                <td v-for="(items, mes, imx) in lista_mes" :key="'C' + icx + '-' + ifx + '-' + imx" class="text-right">
                  <a href="#" @click.prevent="abrir_lancamentos(mes, categoria_filha, items, 'C')" class="card-link">
                    {{ getValor ({ 'categoria.search': categoria_filha, mes: mes }) }}
                  </a>
                </td>
              </tr>
            </template>

            <tr class="table-danger">
              <th class="lead">Saídas</th>
              <td v-for="(items, mes, imx) in lista_mes" :key="'S' + imx" class="text-right">
                {{ getValor ({ 'categoria.ch_natureza': 'D', mes: mes }) }}
              </td>
            </tr>

            <template v-for="(items, categoria, icx) in lista_categoria('D')">

              <tr :key="'D' + icx">
                <td>
                  {{ categoria }}
                </td>
                <td v-for="(items, mes, imx) in lista_mes" :key="'D' + icx + '-' + imx" class="text-right">
                  {{ getValor ({ 'categoria.categoria_mae.search': categoria, mes: mes }) }}
                </td>
              </tr>

              <tr v-for="(filhos, categoria_filha, ifx) in agrupar(items, 'categoria.search')" :key="'DF' + icx + '-' + ifx"
                class="small text-muted">
                <td>
                  <i class="fa fa-caret-right" aria-hidden="true"></i>
                  {{ categoria_filha }}
                </td>
                <td v-for="(items, mes, imx) in lista_mes" :key="'DV' + icx + '-' + ifx + '-' + imx" class="text-right">
                  <a href="#" @click.prevent="abrir_lancamentos(mes, categoria_filha, items, 'D')" class="card-link">
                    {{ getValor ({ 'categoria.search': categoria_filha, mes: mes }) }}
                  </a>
                </td>
              </tr>

            </template>

          </tbody>

          <tfoot>
            <tr class="table-primary">
              <td class="lead">
                {{ parms_info.por_competencia ? 'Resultado' : 'Saldo' }}
              </td>
              <td v-for="(items, mes, imx) in lista_mes" :key="imx" class="text-right">
                {{ getValor ({ mes: mes }) }}
              </td>
            </tr>
            <tr class="table-info" v-if="saldos.length">
              <td class="lead">
                Saldo Acumulado
              </td>
              <td v-for="(items, mes, imx) in lista_mes" :key="imx" class="text-right">
                {{ $util.formatMoeda(getValor ({ mes: mes }, false, true) + ( saldo_com_cheque_especial ? saldo_total : saldo )) }}
              </td>
            </tr>
          </tfoot>

        </table>

        <template v-if="saldos.length">

          <div class="row">
            <div class="col col-12 col-md-6">

              <div class="card carde">
                <div class="card-body">
                  <table class="table table-sm mb-0">
                    <thead>
                      <tr>
                        <th>Composição Saldo Inicial</th>
                        <th class="text-right">Saldo</th>
                        <template v-if="tem_cheque_especial">
                          <th class="text-right">Ch Especial</th>
                          <th class="text-right">Saldo Total</th>
                        </template>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(conta, icx) in lista_saldos" :key="icx">
                        <td>{{ conta.search }}</td>
                        <td class="text-right" :class="conta.saldo < 0 ? 'text-danger' : ''">
                          {{ $util.formatMoeda(conta.saldo) }}
                        </td>
                        <td class="text-right" :class="saldo_com_cheque_especial ? '' : 'text-muted'" v-if="tem_cheque_especial">
                          {{ $util.formatMoeda(conta.dc_cheque_especial) }}
                        </td>
                        <td class="text-right" :class="saldo_com_cheque_especial ? ( conta.saldo_total < 0 ? 'text-danger' : '' ) : 'text-muted'" v-if="tem_cheque_especial">
                          {{ $util.formatMoeda(conta.saldo_total) }}
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <th>Total</th>
                        <th class="text-right" :class="saldo < 0 ? 'text-danger' : ''">
                          {{ $util.formatMoeda (saldo) }}
                        </th>
                        <template v-if="tem_cheque_especial">
                          <th class="text-right" :class="saldo_com_cheque_especial ? '' : 'text-muted'">
                            {{ $util.formatMoeda(chequeEspecial) }}
                          </th>
                          <th class="text-right" :class="saldo_com_cheque_especial ? ( saldo_total < 0 ? 'text-danger' : '' ) : 'text-muted'">
                            {{ $util.formatMoeda(saldo_total) }}
                          </th>
                        </template>
                      </tr>
                    </tfoot>
                  </table>

                </div>

                <div class="card-footer d-flex justify-content-between" v-if="( options_classes && options_classes.length ) || tem_cheque_especial">
                  <div>
                    <a href="#" @click.prevent="( tag_selected == tag ? tag_selected = '' : tag_selected = tag );"
                      v-for="(tag, itx) in options_classes" :key="itx">
                      <span class="badge ml-1" :class="tag_selected == tag ? 'badge-success' : 'badge-secondary'">
                          {{ tag }}
                      </span>
                    </a>
                  </div>
                  <div class="custom-control custom-switch" v-if="tem_cheque_especial">
                    <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="saldo_com_cheque_especial">
                    <label class="custom-control-label" for="customSwitch1">Cheque Especial</label>
                  </div>
                </div>

              </div>

            </div>

          </div>

          <pre v-if="false">{{ dados }}</pre>

        </template>

      </div>

      -->

      <template v-if="aba != 'dre'">

        <div class="row">
          <div class="col col-12 col-md-6">
            <div class="card carde">
              <div class="card-header">
                {{ aba == 'dre' ? 'Receitas e Despesas' : 'Entradas e Saídas' }}
              </div>
              <div class="card-body">
                <Chart 
                  :type="qt_colunas == 1 ? 'bar' : 'line'" 
                  :data="grafico_in_out ()" 
                  :options="{ 
                      legend: { display: true },
                      scales: {
                          yAxes: [{
                              ticks: {
                                  callback: function(value, index, values) {
                                      return formatMoedaGrafico(value);
                                  }
                              }
                          }],
                      }
                    }" />
              </div>
            </div>
          </div>
          <div class="col col-12 col-md-6">
            <div class="card carde">
              <div class="card-header">
                {{ parms_info.por_competencia ? 'Resultado Acumulado' : 'Geração de Caixa' }}
              </div>
              <div class="card-body">
                <Chart 
                  :type="qt_colunas == 1 ? 'bar' : 'line'" 
                  :data="grafico_geracao()" 
                  :options="{ 
                      legend: { display: true },
                      scales: {
                          yAxes: [{
                              ticks: {
                                  callback: function(value, index, values) {
                                      return formatMoedaGrafico(value);
                                  }
                              }
                          }],
                      }
                    }" />
              </div>
            </div>
          </div>
        </div>

      </template>

      <pre v-if="1 == 0">{{ fluxo }}</pre>
      <pre v-if="1 == 0">{{ dadosFormatados }}</pre>

    </template>

    <lancamentos-modal ref="lancs" />

  </div>
</template>

<script>
import _ from 'lodash';
import * as moment from 'moment';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import PrintExport from '../../shared/PrintExport.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import LancamentosModal from './LancamentosModal.vue';

export default {
  data() {
    return {
      dados: null,
      referencia: this.$util.hoje().substr(0,7),
      por_competencia: false, 
      tipo: "P",
      tempo: 'mensal',
      dateFormat: 'MMM/YYYY',
      saldos: null,
      options_classes: [], 
      saldo_com_cheque_especial: true, 
      tag_selected: "", 
      range_from: 1,
      range_to: 31,
      montando: true, 
      id_unidade_operacao: "", 
      fluxo: null, 
      firstLoad: false, 
      filtro: { 
        periodo: "ms",
        inicio: null,
        fim: null, 
        mes_inicial: moment().subtract(2, "months").format('YYYY-MM'),
        mes_final: moment().add(2, "months").format('YYYY-MM'),
        search: "", 
        tipo_operacional: "", 
        consolidado: false, 
        tipo_filtro_unidade: 'L', 
        id_centro_custo: "", 
      },
      info_periodo: null, 
      exibe_percentual: true, 
      percentual_sobre_entradas: false, 
      particular_forma: false, 
      exibe_media: true, 
      expandido: true, 
      parms_info: null, 
      total_frente: true, 
      cheque_espcial: false, 
      transfs: null,
      exibir_composicao_saldo_inicial: false, 
      modelos: [], 
      id_modelo_categoria_selec: "", 
    };
  },
  components: { 
    AzEmptyState, 
    AzInput,
    AzPeriodo,
    PrintExport, 
    LancamentosModal, 
  },

  watch: { 
    aba: function (newValue) { 
      this.dados = null;
      this.firstLoad = false;
      this.tipo = 'P';

      this.por_competencia = ( newValue == 'dre' );

      if ( newValue == 'dre' ) { 
        this.filtro.periodo = 'ma';
      } else { 
        this.filtro.periodo = 'ms';
      }
    },

    referencia: function () { 
      //this.load();
    },

    por_competencia: function () { 
      if ( this.por_competencia )
        this.tempo = 'mensal';

      //this.load();
    },

    tempo: function () { 
      //this.load();
    },

    tipo: function () { 
      //this.load();
    },

    exibe_percentual: function (newValue) { 
      this.$util.setCookie('fc-perc', newValue ? 'S' : 'N');
    },

    exibe_media: function (newValue) { 
      this.$util.setCookie('fc-media', newValue ? 'S' : 'N');    
    },

    percentual_sobre_entradas: function (newValue) { 
      this.$util.setCookie('fc-perc-ent', newValue ? 'S' : 'N');
    },

    particular_forma: function (newValue) { 
      this.$util.setCookie('fc-forma', newValue ? 'S' : 'N');    
    },

    total_frente: function (newValue) { 
      this.$util.setCookie('fc-tf', newValue ? 'S' : 'N');
    }
  },

  props: ['aba'], 

  computed: { 
    lista_modelos: function () { 
      if ( !this.modelos ) { 
        return [];
      }

      return this.modelos.filter(modelo => modelo.ch_tipo == ( this.aba == 'dre' ? 'D' : 'F' ));
    },

    titulo_tipo: function () { 
      let titulo; 

      switch (this.tipo) {
        case 'P':  
          titulo = 'Previsto';
          break;

        case 'C':  
          titulo = 'Conciliado';
          break;

        case 'A':  
          titulo = 'Previsto / Em Aberto';
          break;

        case 'G': 
          titulo = 'Previsto/Pagamento';
          break;

        case 'R':
          titulo = 'Realizado';
          break;
      
        default:
          titulo = '?';
          break;
      }

      return titulo;

    },
    lista_centro_custo: function () { 
        if ( !this.id_unidade_operacao )
            return [];

        let unidade = this.$store.state.unidade.unidade_operacaos
            .find(item => item.id_unidade_operacao == this.id_unidade_operacao);

        if ( unidade )
            return unidade.centro_custos;

        return [];
    },

    tem_saldo_operacional: function () { 
      let teste = this.getValor ({ 'categoria.fl_operacional': true });
      return teste != '0,00' && teste != this.getValor ({});
    },

    qt_colunas: function () { 
      return Object.keys(this.lista_mes).length;
    },

    lista_saldos: function () { 

      if ( !this.saldos )
        return [];

      return this.saldos.filter(conta => !this.tag_selected || ( conta.js_classes && conta.js_classes.findIndex(classe => classe == this.tag_selected) >= 0 ));

    },

    lista_mes: function () { 
      if ( !this.dados ) 
        return [];

      return _.groupBy(
          this.dados.filter(item => this.tempo != 'diario' || 
            ( parseInt(item.mes.substr(8,2)) >= this.range_from && 
              parseInt(item.mes.substr(8,2)) <= this.range_to )
          )
          , item => { 
            return item.mes;
          });
    },

    tem_cheque_especial: function () { 
      if ( !this.lista_saldos || !this.cheque_espcial )
        return false;

      return this.lista_saldos.findIndex(item => item.dc_cheque_especial) >= 0;
    },

    chequeEspecial: function () { 
      if ( !this.lista_saldos )
        return 0;

      return _.sumBy(this.lista_saldos, 'dc_cheque_especial');
    },

    saldo () { 

      if ( !this.lista_saldos )
        return 0; 

      return this.lista_saldos.reduce((total, item) => { 
        return total + item.saldo;
      }, 0);
      
    },

    saldo_total: function () { 
      return this.saldo + ( this.cheque_espcial ? this.chequeEspecial : 0 );
    },

    dadosFormatados: function () { 

      if ( !this.dados )
        return;

      let lista = this.fluxo.map(item => { 
          let linha = { 
            categoria: ( item.hierarquia ? item.hierarquia + ' ' : '' ) + item.search,
            Total: this.$util.formatMoeda(
              Math.round(item.lancamentos.reduce((total, lanc) => total + ( lanc.valor * ( lanc.categoria.ch_natureza == 'D' ? -1 : 1 ) ), 0) * 100) / 100
            ),
          }

          _.each(this.lista_mes, (items, mes) => { 
            linha[this.$util.getFormatDate(mes, this.dateFormat).toUpperCase()] = this.$util.formatMoeda(
              Math.round(
                item.lancamentos.filter(lanc => lanc.mes == mes)
                  .reduce((total, lanc) => total + ( lanc.valor * ( lanc.categoria.ch_natureza == 'D' ? -1 : 1 ) ), 0) * 100) / 100
            );
          });

          return linha;
        });

      let total = { 
        categoria: 'SALDO',
        Total: this.getValor ({}), 
      }; 

      _.each(this.lista_mes, (items, mes) => { 
        total[this.$util.getFormatDate(mes, this.dateFormat).toUpperCase()] = this.getValor ({ mes: mes });
      });

      lista.push(total);

      return lista;

    },

    denominador_percentual_oper: function () { 
      if ( !this.fluxo )
        return 0;

      let denominador_base = this.fluxo.find(item_fluxo => item_fluxo.id_categoria === 0 && item_fluxo.cor == 'success' && ( item_fluxo.operacional || this.parms_info.tipo_operacional == 'S' ));
      let denominador = 0;

      if ( denominador_base && denominador_base.lancamentos ) { 
        denominador = this.getValor({}, false, false, denominador_base.lancamentos);
      }

      return denominador;
    },

    denominador_percentual_noper: function () { 
      if ( !this.fluxo )
        return 0;

      let denominador_base = this.fluxo.find(item_fluxo => item_fluxo.id_categoria === 0 && item_fluxo.cor == 'success' && ( !item_fluxo.operacional ||  this.parms_info.tipo_operacional == 'N' ));
      let denominador = 0;

      if ( denominador_base && denominador_base.lancamentos ) { 
        denominador = this.getValor({}, false, false, denominador_base.lancamentos);
      }

      return denominador;
    }
  },

  methods: { 
    toggle_expandido (linha = null) { 
      if ( !linha ) { 
        this.expandido = !this.expandido;
        this.fluxo.forEach(item => { 
          if ( item.folha ) { 
            item.expandido = this.expandido;
            item.visivel = this.expandido;
          } else { 
            item.expandido = this.expandido;
            item.visivel = true;
          }
        });
        return;
      }
      
      linha.expandido = !linha.expandido;

      let ids = linha.lancamentos.map(item => item.id_categoria);

      this.fluxo.filter(item => item.nivel > linha.nivel || ( !linha.nivel && item.ordem > linha.ordem ))
        .forEach(item => { 
            if ( item.lancamentos.find(item => ids.find(id => id == item.id_categoria)) ) { 
              item.expandido = linha.expandido;
              item.visivel = linha.expandido;
            }
        });
    },

    validar_pesquisa (linha) { 
      /*
      if ( !this.expandido && ( linha && !linha.cor ) ) { 
        return false;
      }
      */

      if ( !linha.visivel )
        return false;

      if ( !this.filtro.search ) { 
        return true;
      }

      let reg = this.$util.getregex(this.filtro.search);
            
      return reg.test(JSON.stringify(linha));
    },

    abrir_lancamentos(mes, categoria_filha, items, natureza, id_categoria = null, id_forma_pagamento = null) { 
      let lista = items.filter(item => item.categoria && item.categoria.search == categoria_filha);

      if ( lista.find(item => item.origem == 'A') ) { 
        this.$toast.add({
          severity: "info",
          summary: "Detalhe",
          detail: "Valores baseados em atendimento. O detalhamento deve ser verificado na visão geral ou em relatórios.",
          life: 3000
        });
        return;
      }

      if ( lista.find(item => item.origem == 'C') ) { 
        this.$toast.add({
          severity: "info",
          summary: "Detalhe",
          detail: "Valores baseados em consumo de materiais. O detalhamento deve ser verificado na módulo de suprimentos ou em relatórios.",
          life: 3000
        });
        return;
      }

      if ( lista.find(item => item.origem == 'R') ) { 
        this.$emit('abririmp', {mes: mes, tempo: this.tempo, natureza: natureza});
        return;
      }

      let parms = { 
        mes: mes, 
        categoria: categoria_filha, 
        id_categoria: id_categoria, 
        natureza: natureza,
        id_unidade_operacao: this.id_unidade_operacao,
        id_centro_custo: this.filtro.id_centro_custo ? this.filtro.id_centro_custo : "",
        id_forma_pagamento: id_forma_pagamento, 
        tipo_data: this.por_competencia ? 'C' 
          : ( this.tipo == 'R' || this.tipo == 'C' ) ? 'B' : '', 
        tipo: this.tipo, 
        tempo: this.tempo, 
        conciliado: this.tipo == 'C', 
        origem: ( this.aba != 'dre' && ( this.tipo == 'R' || this.tipo == 'C' ) ) ? 'B' : 'L',  
        dre: this.aba == 'dre', 
        status: this.tipo == 'A' ? 'A' : '',
      };

      this.$refs.lancs.abrir(parms);
    },

    valores_grafico() { 

      if ( !this.dados )
        return [];

      let acc = 0;

      let valores = _.map(
        this.lista_mes,
        (items, mes) => { 
          let entrada = this.getValor ({ 'categoria.ch_natureza': 'C', mes: mes, formula: false }, false);
          let saida = this.getValor ({ 'categoria.ch_natureza': 'D', mes: mes, formula: false }, false) * -1;
          let saldo = entrada - saida;

          acc = acc + saldo;

          return { 
            label: mes,
            entradas: entrada, 
            saidas: saida,
            saldo: saldo,
            acumulado: acc, 
          }
        }
      );

      return _.orderBy(valores, 'label', 'asc');

    },

    grafico_in_out() { 

      let valores = this.valores_grafico();

      let grafico = {
				labels: _.map(valores, (item) => { 
            return this.$util.getFormatDate(item.label, this.dateFormat).toUpperCase();
        }),
            datasets: [
                {
                    label: this.aba == 'dre' ? 'Receitas' : 'Entradas',
                    lineTension: 0,
                    backgroundColor: 'rgba(0,255,0,0.1)',
                    borderColor: '#33CC11',
                    fill: true, 
                        data: _.map(valores, (item) => { 
                            return Math.round(item.entradas * 100) / 100;
                        })
                },
                {
                    label: this.aba == 'dre' ? 'Despesas' : 'Saídas',
                    lineTension: 0,
                    backgroundColor: 'rgba(255,0,0,0.1)',
                    borderColor: '#CC0000',
                    fill: true, 
                        data: _.map(valores, (item) => { 
                            return Math.round(item.saidas * 100) / 100;
                        })
                }
			]
      };
            
      return grafico;

    },

    grafico_geracao() { 

      let valores = this.valores_grafico();

      let grafico = {
				labels: _.map(valores, (item) => { 
            return this.$util.getFormatDate(item.label, this.dateFormat).toUpperCase();
        }),
        datasets: [
			{
                label: 'Geração',
                lineTension: 0,
                backgroundColor: 'rgba(0,0,255,0.1)',
                borderColor: '#1133CC',
                fill: true, 
                    data: _.map(valores, (item) => { 
                        return Math.round(item.saldo * 100) / 100;
                    })
            },
            {
                label: 'Acumulado',
                lineTension: 0,
                backgroundColor: 'rgba(0,0,255,0.1)',
                borderColor: '#33CC11',
                fill: true, 
                    data: _.map(valores, (item) => { 
                        return Math.round(item.acumulado * 100) / 100;
                    })
            }
		]
      };
            
      return grafico;

    },

    formatMoedaGrafico(value) { 
        let show = this.$util.formatMoeda(value);
        return show.substr(0,show.length - 3);
    },
    
    lista_categoria (natureza) { 
      if ( !this.dados ) 
        return [];

      return _.groupBy(
        _.orderBy(
          this.dados.filter(item => item.categoria.ch_natureza == natureza),
          item => { 
            return item.categoria ? item.categoria.categoria_mae.in_regra_ordem : 99999;
          }
        ), 
        item => { 
          return item.categoria ? item.categoria.categoria_mae.search : '?';
        }
      );
    },

    agrupar (dados, campo) {

      if ( !dados ) 
        return [];

      return _.groupBy(
        _.orderBy(dados, item => item.categoria ? item.categoria.in_regra_ordem : 99999), 
        item => _.get(item, campo)
      );
        
    },

    percentual (filtros, format = true, acumulado = false, lista = null, linha) { 

      if ( !this.dados || !lista )
        return;

      if ( !this.percentual_sobre_entradas && linha.cor == 'primary' ) { 
        return;
      }

      let tipo = ( linha && linha.natureza == 'C' ) ? 'C' : 'D';
      
      let numerador = this.getValor(filtros, false, acumulado, lista, false, linha);
      let denominador;

      if ( this.percentual_sobre_entradas ) { 

        denominador = ( this.parms_info.tipo_operacional && linha && !linha.operacional )
          ? this.denominador_percentual_noper
          : this.denominador_percentual_oper;

      } else { 

        let filtros_denominador = { 'categoria.ch_natureza': ( this.percentual_sobre_entradas ? 'C' : tipo ) };

        if ( !this.percentual_sobre_entradas && linha.cor == 'primary' ) { 
          filtros_denominador = { 'categoria.fl_operacional': linha.operacional };
        }

        denominador = this.getValor(filtros_denominador, false, acumulado, this.dados);

      }

      if ( this.percentual_sobre_entradas && tipo == 'D' ) { 
        denominador = denominador * -1;
      }

      let valor = denominador ? Math.round((numerador / denominador) * 100 * 100) / 100 : 0;

      return format ? this.$util.formatMoeda(valor) : valor;

    },

    getValorTransf (filtros, format = true, acumulado = false) { 

      if ( !this.transfs )
        return 0;

      //if ( !lista ) { 
        let lista = this.transfs;
      //}

      let items = lista.filter(item => { 
        return !_.find(filtros, (valor, chave) => acumulado ? _.get(item, chave) > valor : _.get(item, chave) !== valor) ;
      });

      let valor = items.reduce((total, item) => ( total + item.valor ), 0);

      /*
      if ( media && this.qt_colunas ) { 
        valor = valor / this.qt_colunas;
      }
      */

      return format ? this.$util.formatMoeda(valor) : valor;

    },

    getValor (filtros, format = true, acumulado = false, lista = null, media = false, linha = null) { 

      if ( !lista ) { 
        lista = this.dados;
      }

      let items = lista.filter(item => { 
        return ( !item.consolid || ( linha && linha.formula ) )  
          && !_.find(filtros, (valor, chave) => acumulado ? _.get(item, chave) > valor : _.get(item, chave) !== valor) ;
      });

      let valor = items.length 
        ? items.reduce((total, item) => ( total + ( item.valor * ( item.categoria.ch_natureza == 'D' ? -1 : 1 ) ) ), 0)
        : 0;

      if ( media && this.qt_colunas ) { 
        valor = valor / this.qt_colunas;
      }

      return format ? this.$util.formatMoeda(valor) : valor;

    },

    load () { 
      if ( this.montando )
        return;

      this.$util.load(this, { 
        service: 'financeiro',
        func: 'fluxo_de_caixa', 
        parms: { 
          //referencia: this.referencia, 
          ...this.filtro, 
          por_competencia: this.por_competencia, 
          particular_forma: this.particular_forma, 
          tempo: this.aba == 'dre' ? 'mensal' : this.tempo, 
          tipo: this.tipo, 
          id_unidade_operacao: this.id_unidade_operacao, 
          aba: this.aba, 
          id_modelo_categoria: this.id_modelo_categoria_selec,
        }, 
        loadTo: (dados) => { 
          this.firstLoad = true;
          
          this.dateFormat = ( this.tempo == 'diario' || this.tempo == '3D' || this.tempo == 'semana' ) ? 'DD/MM' : 'MMM/YYYY';
          this.dados = dados.lancamentos;
          this.saldos = dados.saldos;
          this.fluxo = dados.fluxo; 
          this.info_periodo = dados.periodo;
          this.parms_info = dados.parms;
          this.transfs = dados.transfs;

          this.$util.setCookie('id_unidade_operacao', isNaN(this.id_unidade_operacao) ? '' : this.id_unidade_operacao);
          this.$util.setCookie('fc-oper', this.filtro.tipo_operacional);
          this.$util.setCookie(( this.aba == 'dre' ? 'dre' : 'fc' ) + '-md', this.id_modelo_categoria_selec);
        }
      });
    },

    remount() { 

      this.$store.commit("setBreadcrumb", [
        { name: "Financeiro", path: "/financeiro/visao" },
        { name: ( this.aba == 'dre' ? "DRE" : "Fluxo de Caixa" ) , path: "/financeiro/" + this.aba }
      ]);

      this.id_modelo_categoria_selec = this.$util.getCookie(( this.aba == 'dre' ? 'dre' : 'fc' ) + '-md');

    },

  },

  beforeMount() { 
    this.id_unidade_operacao = this.$store.state.user.id_unidade_operacao
      ? this.$store.state.user.id_unidade_operacao
      : this.$util.getCookie('id_unidade_operacao');

    this.exibe_media = this.$util.getCookie('fc-media') == 'S' ? true : false;
    this.exibe_percentual = this.$util.getCookie('fc-perc') == 'S' ? true : false;
    this.percentual_sobre_entradas = this.$util.getCookie('fc-perc-ent') == 'S' ? true : false;
    this.particular_forma = this.$util.getCookie('fc-forma') == 'S' ? true : false;
    this.total_frente = this.$util.getCookie('fc-tf') == 'N' ? false : true;

    if ( this.$util.getCookie('fc-oper') ) { 
      this.filtro.tipo_operacional = this.$util.getCookie('fc-oper');
    }

    this.por_competencia = ( this.aba == 'dre' );

    if ( this.aba == 'dre' ) { 
      this.filtro.periodo = 'ma';
    }
    
  },

  mounted() {
    this.remount(); 

    /*
    this.$store.commit("setBreadcrumb", [
      { name: "Financeiro", path: "/financeiro/visao" },
      { name: ( this.aba == 'dre' ? "DRE" : "Fluxo de Caixa" ) , path: "/financeiro/" + this.aba }
    ]);

    this.id_modelo_categoria_selec = this.$util.getCookie(( this.aba == 'dre' ? 'dre' : 'fc' ) + '-md');
    */

    this.$util.loadItem(this, { 
      service: 'modelo_categorias', 
      func: 'index', 
      parms: { 
        ativos: true, 
      }
    })
    .then(res => { 
      this.modelos = res;
    });

    if ( this.$store.state.contexto && this.$store.state.contexto.fluxo_conta_tags ) {

      this.options_classes = this.$store.state.contexto.fluxo_conta_tags;

      if ( this.options_classes.find(item => item == 'Geral') ) { 
        this.tag_selected = 'Geral';
      } 

    } else { 
    
      this.$util.loadItem(this, { 
          service: 'contas',
          func: 'tags',
      })
      .then(res => { 
          this.options_classes = res;

          this.$store.commit('setContexto', { fluxo_conta_tags: res });

          if ( this.options_classes.find(item => item == 'Geral') ) { 
            this.tag_selected = 'Geral';
          } 
      });

    }

    this.$nextTick(() =>  { 
      this.montando = false;
      // this.load();
    });

  },
  
};
</script>